import React, { Suspense, useEffect } from 'react';
import { useQuery } from "react-query";
import * as apiClient from "../api-client";
import '../index.css';
import Loader from '../components/LoaderComponent';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import BlogSliderType from '../components/Blogs/BlogSliderType';
import HolidayTypeHotelsList from '../components/HolidayTypeHotelList';
import Slider1 from "../components/Sliders/AllExclusiveSlider";
import Slider2 from "../components/Sliders/AllExclusiveCoupleSlider";
import Slider3 from "../components/Sliders/AllExclusiveFamilySlider";
// import Slider2 from "../components/CountrySliders/Mauritius/AllInclusiveSlider";
// import Slider3 from "../components/CountrySliders/Dominican-Republic/AllInclusiveSlider";
import HotelSliderSkeleton from '../components/Skeletons/HotelSliderSkeleton';
import ExclusiveSect from '../components/ExclusiveSection1';
import ReadMoreLines from '../components/ReadMoreLines';
// import LinkButton from '../components/Common/LinkButton';

// const LazyWhyChoose = React.lazy(() => import('../components/Home/WhyChoose'));
const LazyVacationTypes = React.lazy(() => import('../components/Home/VacationTypes'));

const PageAllExclusive = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { data: hotels } = useQuery("fetchAllExclusiveHotels", apiClient.fetchHotels);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>All-Exclusive Holidays | Luxury Travel | Halo Holidays</title>
          <meta name="description" content="Discover all-exclusive holidays with Halo Holidays.  Experience personalized service, curated adventures, and unparalleled luxury in breathtaking destinations." />
        </Helmet>
      </HelmetProvider>
      <section className="mx-4 my-4 md:mx-0 md:my-0">

        <div>
          <h2 className="text-2xl font-semibold mt-2">Discover Our All-Exclusive Holidays</h2>
          <ReadMoreLines mobileMaxRows={2} desktopMaxRows={2}>
            <p className="text-black mb-2">
              For those who seek the ultimate in privacy, luxury, and personalized service, Halo Holidays’ All-Exclusive Holidays offer an experience like no other. Escape to exclusive resorts featuring private accommodations, unmatched amenities, and exceptional service that caters to your every need. Our all-exclusive holidays are designed to redefine luxury travel.
            </p>
            <br />
            <h3 className='text-xl font-semibold'>Benefits of Choosing All-Exclusive Holidays</h3>
            <p className='text-black'>
              An all-exclusive holiday isn’t just about luxury; it’s about elevating every detail to create an unforgettable experience. Here’s why our exclusive getaways are ideal for discerning travelers:
            </p>
            <ul className="sitemap-bullet pl-6 mt-4 text-gray-600">
              <li><span className='font-medium text-black'>Enhanced Privacy</span> – Enjoy total privacy with exclusive villas, personal pools, and limited-access amenities.</li>
              <li><span className='font-medium text-black'>Personalized Service</span> – From your dedicated butler to private chefs, everything is tailored for you.</li>
              <li><span className='font-medium text-black'>Unique, Private Experiences</span> – Discover private excursions, bespoke spa treatments, and one-of-a-kind moments.</li>
              <li><span className='font-medium text-black'>Effortless Travel</span> – With every detail handled by Halo Holidays, you can relax and enjoy every moment.</li>
            </ul>
            <h3 className='text-xl font-semibold mt-2'>Customize Your Flights for the Ultimate All-Exclusive Holiday</h3>
            <p className='text-black'>
              All Exclusives Holidays are always better paired with the right right type of flights. That’s why our All-Exclusive Holidays include the option to customize your flights according to your preferences. Whether you’re looking for Business Class comfort or First Class luxury. We offer flexible options to ensure every part of your journey is as exclusive as your stay.
            </p>
            <p className='text-black mt-2'>
              Choose from a range of flight options:
            </p>
            <ul className="sitemap-bullet pl-6 mt-4 text-gray-600">
              <li><span className='font-medium text-black'>Business/First Class Seats</span> – Relax with spacious seating, gourmet dining, and exceptional service on board.</li>
              <li><span className='font-medium text-black'>Flexible Airlines</span> – Select your preferred airline from our trusted partners for a seamless experience.</li>
              <li><span className='font-medium text-black'>Convenient Connections</span> – Choose flights with ideal layovers or direct options to suit your schedule and comfort.</li>
              <li><span className='font-medium text-black'>Upgrade Options</span> – Enjoy the opportunity to upgrade your travel with exclusive benefits and rewards.</li>
            </ul>
          </ReadMoreLines>
        </div>

        <Suspense fallback={<Loader />}>
          <section className='my-4'>
            <div className="hidden md:block lg:block lgx2:block">
              {hotels && (
                <HolidayTypeHotelsList hotels={hotels} holidayType="All Exclusive" />
              )}
            </div>
            <Suspense fallback={<HotelSliderSkeleton />}>
              <div className="container md:hidden lg:hidden">
                <Slider1 hotels={hotels ?? []} />
              </div>
            </Suspense>
          </section>
        </Suspense>

        <Suspense fallback={<Loader />}>
          <div className='my-8'>
            <ExclusiveSect />
          </div>
        </Suspense>

        <div>
          <h2 className="text-2xl font-semibold mt-2">Romantic All-Exclusive Getaways for Couples</h2>
          <ReadMoreLines mobileMaxRows={2} desktopMaxRows={1}>
            <p className='text-black'>
              For couples looking for the ultimate romantic escape, our all-exclusive holidays are designed to enhance every romantic moment. Expect privacy, personalized service, and enchanting experiences:
            </p>
            <ul className="sitemap-bullet pl-6 mt-4 text-gray-600">
              <li><span className='font-medium text-black'>Private Beachfront Villas</span> – Enjoy secluded stays with stunning ocean views.</li>
              <li><span className='font-medium text-black'>Candlelit Dining on the Beach</span> – From private dinners on the beach to in-villa chef-prepared meals.</li>
              <li><span className='font-medium text-black'>Couples Spa Experiences</span> – Customized spa packages, including couples massages and treatments.</li>
              <li><span className='font-medium text-black'>Unforgettable Adventures</span> – Private yacht cruises, sunset picnics, or helicopter tours, all arranged for you.</li>
            </ul>
            <p className='text-black mt-2'>
              Celebrate romance in unparalleled style with our all-exclusive holidays, where each detail is made just for you.
            </p>

          </ReadMoreLines>
        </div>

        <Suspense fallback={<Loader />}>
          <section className='my-4'>
            <div className="hidden md:block lg:block lgx2:block">
              {hotels && (
                <HolidayTypeHotelsList hotels={hotels} holidayType="All Exclusive Couple" />
              )}
            </div>
            {/* <div className='hidden md:block lg:block lgx2:block'>
              <LinkButton to='/all-exclusive-couple-holidays' btnDescription='View All Deals' />
            </div> */}
            <Suspense fallback={<HotelSliderSkeleton />}>
              <div className="container md:hidden lg:hidden">
                <Slider2 hotels={hotels ?? []} />
              </div>
            </Suspense>
          </section>
        </Suspense>
        <hr className="mb-10 mt-10" />

        <div>
          <h2 className="text-2xl font-semibold mt-2">Exclusive Family Holidays</h2>
          <ReadMoreLines mobileMaxRows={2} desktopMaxRows={1}>
            <p className='text-black'>
              Traveling with family doesn’t mean sacrificing luxury or privacy. Our exclusive family holidays offer spacious accommodations, personalized services, and memorable experiences that cater to all ages:
            </p>
            <ul className="sitemap-bullet pl-6 mt-4 text-gray-600">
              <li><span className='font-medium text-black'>Family-Friendly Villas</span> – Private residences with enough space for everyone to enjoy.</li>
              <li><span className='font-medium text-black'>Dedicated Family Concierge</span> – A concierge to plan family activities, ensuring everyone has an unforgettable experience.</li>
              <li><span className='font-medium text-black'>Tailored Experiences for Kids</span> – Private kids’ clubs, educational excursions, and supervised activities.</li>
              <li><span className='font-medium text-black'>Personalized Dining Options</span> – Menus to satisfy every family member’s taste and dietary needs.</li>
            </ul>
            <p className='text-black mt-2'>
              Our all-exclusive holidays let families enjoy luxury and privacy while creating lasting memories together.
            </p>

          </ReadMoreLines>
        </div>

        <Suspense fallback={<Loader />}>
          <section className='my-4'>
            <div className="hidden md:block lg:block lgx2:block">
              {hotels && (
                <HolidayTypeHotelsList hotels={hotels} holidayType="All Exclusive Family" />
              )}
            </div>
            {/* <div className='hidden md:block lg:block lgx2:block'>
              <LinkButton to='/all-exclusive-family-holidays' btnDescription='View All Deals' />
            </div> */}
            <Suspense fallback={<HotelSliderSkeleton />}>
              <div className="container md:hidden lg:hidden">
                <Slider3 hotels={hotels ?? []} />
              </div>
            </Suspense>
          </section>
        </Suspense>
        <hr className="mb-10 mt-10" />

        <Suspense fallback={<div>Loading Holiday Types...</div>}>
          <div className='p-4 md:p-0'>
            <LazyVacationTypes />
          </div>
        </Suspense>
        <hr className="mb-10 mt-10" />

        <section className='p-4 md:p-0'>
          <h2 className='text-2xl font-semibold mb-2'>Related Blogs</h2>
          <BlogSliderType blogType='all_inclusive' />
        </section>

      </section>
    </>
  );
};

export default PageAllExclusive;
